// Campus photo for /colleges/texas-a-m-university: CC BY-SA 4.0, by Kailynn.Nelson, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ATexas_A%26M_Academic_Building.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/texas-a-m-university/; credited under the photo.
const photo = {
    "slug": "texas-a-m-university",
    "alt": "The domed Academic Building at Texas A&M University seen past live oaks and campus walkways",
    "src": "/colleges/texas-a-m-university/campus-1600.webp",
    "srcSmall": "/colleges/texas-a-m-university/campus-800.webp",
    "srcMid": "/colleges/texas-a-m-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/texas-a-m-university/og.jpg",
    "title": "Texas A&M Academic Building",
    "author": "Kailynn.Nelson",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ATexas_A%26M_Academic_Building.jpg",
    "read": "2026-10-01"
};

export default photo;
